import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { LazyFindRetailSpace } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/find-retail-space/LazyFindRetailSpace";
import { LazyGetFundingAndLicenses } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/get-funding-and-licenses/LazyGetFundingAndLicenses";
import { LazyOpenWithFaireFaireAcademyGuideLandingPage } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideLandingPage/LazyOpenWithFaireFaireAcademyLandingPage";
import { LazyLayTheGroundwork } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/lay-the-groundwork/LazyLayTheGroundwork";
import { LazyOrganizeStoreOperations } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/organize-store-operations/LazyOrganizeStoreOperations";
import { LazyPlanAndBuyInventory } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/plan-and-buy-inventory/LazyPlanAndBuyInventory";
import { LazyPromoteYourStore } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/promote-your-store/LazyPromoteYourStore";
import { LazyRenovateYourStore } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/renovate-your-store/LazyRenovateYourStore";
import { LazyOpenWithFaireFaireAcademyLandingPage } from "@faire/retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/LazyOpenWithFaireFaireAcademyLandingPage";
import { Route } from "@faire/web--source/ui/routing/Route";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { props as openWithFaireRouteProps } from "@faire/web-api--source/routes/open-with-faire";
import { props as openWithFaireAcademyProps } from "@faire/web-api--source/routes/open-with-faire/academy";
import { props as openWithFaireAcademyBuyRetailInventoryProps } from "@faire/web-api--source/routes/open-with-faire/academy/buy-retail-inventory";
import { props as openWithFaireAcademyFindRetailSpaceProps } from "@faire/web-api--source/routes/open-with-faire/academy/find-retail-space";
import { props as openWithFaireAcademyGetFundingAndLicensesProps } from "@faire/web-api--source/routes/open-with-faire/academy/funding-licensing";
import { props as openWithFaireAcademyLayTheGroundworkProps } from "@faire/web-api--source/routes/open-with-faire/academy/lay-the-groundwork";
import { props as openWithFaireAcademyOrganizeStoreOperationsProps } from "@faire/web-api--source/routes/open-with-faire/academy/organize-store-operations";
import { props as openWithFaireAcademyPromoteYourStoreProps } from "@faire/web-api--source/routes/open-with-faire/academy/promote-your-store";
import { props as openWithFaireAcademyRenovateYourStoreProps } from "@faire/web-api--source/routes/open-with-faire/academy/renovate-your-store";
import React from "react";
var ACADEMY_GUIDE_ROUTES = [
    {
        routeProps: openWithFaireAcademyLayTheGroundworkProps,
        component: LazyLayTheGroundwork
    },
    {
        routeProps: openWithFaireAcademyGetFundingAndLicensesProps,
        component: LazyGetFundingAndLicenses
    },
    {
        routeProps: openWithFaireAcademyFindRetailSpaceProps,
        component: LazyFindRetailSpace
    },
    {
        routeProps: openWithFaireAcademyRenovateYourStoreProps,
        component: LazyRenovateYourStore
    },
    {
        routeProps: openWithFaireAcademyBuyRetailInventoryProps,
        component: LazyPlanAndBuyInventory
    },
    {
        routeProps: openWithFaireAcademyOrganizeStoreOperationsProps,
        component: LazyOrganizeStoreOperations
    },
    {
        routeProps: openWithFaireAcademyPromoteYourStoreProps,
        component: LazyPromoteYourStore
    }
];
export var OpenWithFaireRouter = function() {
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, openWithFaireAcademyProps), {
                exact: true,
                component: LazyOpenWithFaireFaireAcademyGuideLandingPage
            })),
            ACADEMY_GUIDE_ROUTES.map(function(param) {
                var routeProps = param.routeProps, component = param.component;
                return /*#__PURE__*/ _createElement(Route, _object_spread_props(_object_spread({}, routeProps), {
                    exact: true,
                    key: routeProps.path,
                    component: component
                }));
            }),
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, openWithFaireRouteProps), {
                component: LazyOpenWithFaireFaireAcademyLandingPage
            }))
        ]
    });
};
